import React from 'react';
import'./textarea.css'

const Textarea = (props) => {
    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt'>{props.title}</label>
            <textarea className={props.stylee} type={props.type} 
            placeholder={props.placeholder}
                onChange={props.onChange} 
                value={props.value}/>
        </fieldset>
     );
}
 
export default Textarea;